// Player Status Types for the New System

export interface PlayerAttendanceStatus {
  id: string;
  gameId: string;
  playerId: string;
  playerType: 'supabase' | 'internal';
  teamSide: 'home' | 'away';
  attendanceStatus: 'attending' | 'not_attending';
  setBy: string;
  setAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface PlayerReadinessStatus {
  id: string;
  gameId: string;
  playerId: string;
  playerType: 'supabase' | 'internal';
  teamSide: 'home' | 'away';
  readinessStatus: 'present_ready_to_play' | 'injured' | 'no_show' | 'disqualified_requirements';
  setBy: string;
  setByType: 'supabase' | 'internal';
  setByRole: 'coach' | 'team_owner' | 'venue';
  overrideLevel: number; // 1: coach/team_owner, 2: venue
  notes?: string;
  setAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface PlayerWithStatusInfo {
  id: string;
  playerType: 'supabase' | 'internal';
  firstName?: string;
  lastName?: string;
  username?: string;
  attendanceStatus?: PlayerAttendanceStatus;
  readinessStatus?: PlayerReadinessStatus;
  teamSide: 'home' | 'away';
}

export const COACH_READINESS_OPTIONS = [
  { value: 'present_ready_to_play', label: 'Present - Ready to Play' },
  { value: 'injured', label: 'Injured' },
  { value: 'no_show', label: 'No Show' }
] as const;

export const VENUE_READINESS_OPTIONS = [
  { value: 'present_ready_to_play', label: 'Present - Ready to Play' },
  { value: 'injured', label: 'Injured' },
  { value: 'no_show', label: 'No Show' },
  { value: 'disqualified_requirements', label: 'Disqualified (Does not Meet Requirements)' }
] as const;

export const ATTENDANCE_OPTIONS = [
  { value: 'attending', label: 'Attending' },
  { value: 'not_attending', label: 'Not Attending' }
] as const;